/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationListItem } from './ApplicationListItem'
import {
  ApplicationListItemFromJSON,
  ApplicationListItemFromJSONTyped,
  ApplicationListItemToJSON,
} from './ApplicationListItem'
import type { ApplicationListMeta } from './ApplicationListMeta'
import {
  ApplicationListMetaFromJSON,
  ApplicationListMetaFromJSONTyped,
  ApplicationListMetaToJSON,
} from './ApplicationListMeta'
import type { Paginate } from './Paginate'
import {
  PaginateFromJSON,
  PaginateFromJSONTyped,
  PaginateToJSON,
} from './Paginate'

/**
 *
 * @export
 * @interface GetApplicationList200Response
 */
export interface GetApplicationList200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetApplicationList200Response
   */
  status: boolean
  /**
   *
   * @type {Array<ApplicationListItem>}
   * @memberof GetApplicationList200Response
   */
  data: Array<ApplicationListItem>
  /**
   *
   * @type {Paginate}
   * @memberof GetApplicationList200Response
   */
  pagination?: Paginate
  /**
   *
   * @type {ApplicationListMeta}
   * @memberof GetApplicationList200Response
   */
  meta?: ApplicationListMeta
}

/**
 * Check if a given object implements the GetApplicationList200Response interface.
 */
export function instanceOfGetApplicationList200Response(
  value: object
): value is GetApplicationList200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetApplicationList200ResponseFromJSON(
  json: any
): GetApplicationList200Response {
  return GetApplicationList200ResponseFromJSONTyped(json, false)
}

export function GetApplicationList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetApplicationList200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(ApplicationListItemFromJSON),
    pagination:
      json['pagination'] == null
        ? undefined
        : PaginateFromJSON(json['pagination']),
    meta:
      json['meta'] == null
        ? undefined
        : ApplicationListMetaFromJSON(json['meta']),
  }
}

export function GetApplicationList200ResponseToJSON(
  value?: GetApplicationList200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(ApplicationListItemToJSON),
    pagination: PaginateToJSON(value['pagination']),
    meta: ApplicationListMetaToJSON(value['meta']),
  }
}
